module.exports = __webpack_public_path__ + "static/akanmu-17bca997522a4959067150ac132d65ad.png";